<mat-card class="cardWithShadow">
  <mat-card-content style="padding: 36px 36px 0px 36px">
    <mat-card-title>
      <h2>Egresos de Insumos</h2>
    </mat-card-title>
    <div *ngIf="!isLoading" class="row justify-content-between">
      <div *ngIf="!isLoading" class="row justify-content-between">
        <div class="col-sm-4 w-100">
          <mat-form-field appearance="outline" class="w-100 hide-hint">
            <mat-label>Número de File</mat-label>
            <mat-select
              [(value)]="filterSelectedFileNumber"
              (selectionChange)="applyFilterSelect()"
            >
              <mat-option value="{{ [] }}">No seleccionar</mat-option>
              <mat-option
                *ngFor="let fileNumber of fileNumbers"
                value="{{ fileNumber }}"
                >{{ fileNumber }}</mat-option
              >
            </mat-select>
          </mat-form-field>
        </div>
        <div class="col-sm-4 w-100">
          <mat-form-field appearance="outline" class="w-100 hide-hint">
            <mat-label>ESTADO</mat-label>
            <mat-select
              [(value)]="filterSelectedEstado"
              (selectionChange)="applyFilterSelect()"
            >
              <mat-option value="{{ null }}">No seleccionar</mat-option>
              <mat-option
                *ngFor="let fileStatus of selectableFileStatuses"
                value="{{ fileStatus }}"
                >{{ fileStatus }}</mat-option
              >
            </mat-select>
          </mat-form-field>
        </div>
        <div class="col-sm-4 w-100">
          <mat-form-field appearance="outline" class="w-100 hide-hint">
            <mat-label>Fecha de Operación</mat-label>
            <mat-datepicker-toggle
              matSuffix
              [for]="rangePicker"
            ></mat-datepicker-toggle>

            <mat-date-range-input [rangePicker]="rangePicker">
              <input
                matStartDate
                placeholder="Día/Mes/Año"
                [(ngModel)]="filterStartDate"
              />
              <input
                matEndDate
                placeholder="Día/Mes/Año"
                [(ngModel)]="filterEndDate"
              />
            </mat-date-range-input>

            <mat-date-range-picker #rangePicker>
              <mat-date-range-picker-actions>
                <button mat-raised-button matDateRangePickerCancel>
                  Cancel
                </button>
                <button
                  mat-raised-button
                  color="primary"
                  (click)="applyFilterSelect()"
                  matDateRangePickerApply
                >
                  Filtrar
                </button>
                <button
                  mat-raised-button
                  color="warn"
                  matDateRangePickerCancel
                  (click)="cleanDateSelected()"
                >
                  Limpiar
                </button>
              </mat-date-range-picker-actions>
            </mat-date-range-picker>
          </mat-form-field>
        </div>
        <div class="col-sm-4 w-100">
          <mat-form-field appearance="outline" class="w-100 hide-hint">
            <mat-label>OTRAS SALIDAS</mat-label>
            <mat-select
              [(value)]="filterSelectedOutflowType"
              (selectionChange)="applyFilterSelect()"
            >
              <mat-option value="{{ null }}">No seleccionar</mat-option>
              <mat-option value="{{ 'SALIDA POR VENCIMIENTO' }}"
                >Salida de productos por vencimiento</mat-option
              >
              <mat-option value="{{ 'SALIDA POR DETERIORO' }}"
                >Salida de producto por deterioro</mat-option
              >
              <mat-option value="{{ 'SALIDA POR CONSUMO' }}"
                >Salida de producto por consumo</mat-option
              >
              <mat-option value="{{ 'SALIDA POR OTRO MOTIVO' }}"
                >Salida de producto por otro motivo</mat-option
              >
            </mat-select>
          </mat-form-field>
        </div>
      </div>
      <div class="col-sm-4 w-100">
        <mat-form-field appearance="outline" class="w-100 hide-hint">
          <input
            matInput
            placeholder="Buscar..."
            (keyup)="applyFilter($event)"
          />
          <mat-icon matSuffix>
            <i-tabler name="search" class="icon-20"></i-tabler>
          </mat-icon>
        </mat-form-field>
      </div>
      <div class="w-100 col-sm-4">
        <button
          mat-raised-button
          color="primary"
          aria-label="Agregar Egreso Adicional"
          (click)="openDialogAddAdditionalOutflow()"
        >
          <span
            style="
              display: flex;
              align-items: center;
              justify-content: center;
              gap: 0.5rem;
            "
            ><i-tabler name="arrow-right-from-arc"> </i-tabler> Agregar Egreso
            Adicional</span
          >
        </button>
      </div>
    </div>
  </mat-card-content>

  <mat-card-content
    *ngIf="isLoading"
    class="d-flex flex-col flex-wrap align-items-center justify-content-center"
    style="padding-bottom: 36px"
  >
    <mat-progress-spinner mode="indeterminate"></mat-progress-spinner>
    <p>Cargando Egresos, por favor espere...</p>
  </mat-card-content>

  <mat-card-content
    [style.display]="
      !isLoading && dataSource.filteredData.length !== 0 ? 'block' : 'none'
    "
    style="padding: 36px"
  >
    <mat-card-content *ngIf="!isLoading" class="table-responsive">
      <table
        mat-table
        matSort
        [dataSource]="dataSource"
        class="no-wrap m-t-0 v-middle w-100"
        multiTemplateDataRows
      >
        <ng-container matColumnDef="fileNumber">
          <th
            class="f-w-600 f-s-15 custom-column"
            mat-header-cell
            mat-sort-header
            *matHeaderCellDef
          >
            Número de File
          </th>
          <td
            class="f-s-14 custom-column"
            mat-cell
            *matCellDef="let fileOrOutflow"
          >
            <ng-container *ngIf="fileOrOutflow.outflowType != null">
              SIN FILE
            </ng-container>
            <ng-container *ngIf="fileOrOutflow.outflowType == null">
              {{ fileOrOutflow.fileNumber }}
            </ng-container>
          </td>
        </ng-container>

        <ng-container matColumnDef="fileDisplayState">
          <th
            class="f-w-600 f-s-15 custom-column"
            mat-header-cell
            *matHeaderCellDef
            mat-sort-header
          >
            Estado File / Observación
          </th>
          <td
            class="f-s-14 custom-column"
            mat-cell
            *matCellDef="let fileOrOutflow"
          >
            <ng-container
              *ngIf="
                !!fileOrOutflow?.outflowType && !!fileOrOutflow?.observation
              "
            >
              {{ fileOrOutflow?.observation || '-' }}
            </ng-container>
            <ng-container
              *ngIf="
                fileOrOutflow?.outflowType == null ||
                !fileOrOutflow?.observation
              "
            >
              <span class="file-status">{{
                fileOrOutflow?.fileDisplayState || '-'
              }}</span>
            </ng-container>
          </td>
        </ng-container>

        <ng-container matColumnDef="dateRange">
          <th
            class="f-w-600 f-s-15 custom-column"
            mat-header-cell
            *matHeaderCellDef
            mat-sort-header
          >
            Fecha Operación
          </th>
          <td
            class="f-s-14 custom-column"
            mat-cell
            *matCellDef="let fileOrOutflow"
          >
            <ng-container *ngIf="fileOrOutflow.outflowType != null">
              {{ fileOrOutflow.outflowDate | date: 'dd/MM/yyyy' }}
            </ng-container>
            <ng-container *ngIf="fileOrOutflow.outflowType == null">
              {{ fileOrOutflow.dateRange }}
            </ng-container>
          </td>
        </ng-container>

        <ng-container matColumnDef="lstPaX">
          <th
            class="f-w-600 f-s-15 custom-column"
            mat-header-cell
            *matHeaderCellDef
            mat-sort-header
          >
            N° Pax / Tipo de Salida
          </th>
          <td
            class="f-s-14 custom-column"
            mat-cell
            *matCellDef="let fileOrOutflow"
          >
            <ng-container *ngIf="fileOrOutflow.outflowType == null">
              {{ fileOrOutflow.lstPaX?.length || '-' }}
            </ng-container>
            <ng-container *ngIf="fileOrOutflow.outflowType != null">
              {{ fileOrOutflow.outflowType }}
            </ng-container>
          </td>
        </ng-container>

        <ng-container matColumnDef="egresado">
          <th
            class="f-w-600 f-s-15 custom-column"
            mat-header-cell
            *matHeaderCellDef
          >
            Insumos Retirados
          </th>
          <td
            class="f-s-14 custom-column"
            mat-cell
            *matCellDef="let fileOrOutflow"
          >
            <i-tabler
              matTooltip="No se confirmaron insumos"
              *ngIf="
                !fileOrOutflow?.egresoInsumos && !fileOrOutflow?.outflowType
              "
              name="alert-circle"
              class="icon-24 icon-full-yellow"
            ></i-tabler>
            <i-tabler
              *ngIf="
                fileOrOutflow?.egresoInsumos || !!fileOrOutflow?.outflowType
              "
              matTooltip="Insumos confirmados"
              name="circle-check"
              class="icon-24 icon-full-green"
            ></i-tabler>
          </td>
        </ng-container>

        <ng-container matColumnDef="restriccionesAlimenticias">
          <th
            class="f-w-600 f-s-15 custom-column"
            mat-header-cell
            *matHeaderCellDef
          >
            Restricciones Alimenticias
          </th>
          <td
            class="f-s-14 custom-column"
            mat-cell
            *matCellDef="let fileOrOutflow"
          >
            <i-tabler
              *ngIf="!obtenerRestriccionesAlimenticias(fileOrOutflow)"
              name="circle-x"
              class="icon-24 icon-full-gray"
            ></i-tabler>
            <i-tabler
              *ngIf="obtenerRestriccionesAlimenticias(fileOrOutflow)"
              name="circle-check"
              class="icon-24 icon-full-green"
            ></i-tabler>
          </td>
        </ng-container>

        <ng-container matColumnDef="detalleFile">
          <th
            class="f-w-600 f-s-15 custom-column"
            mat-header-cell
            *matHeaderCellDef
          >
            Detalle File / Insumos
          </th>
          <td
            class="f-s-14 custom-column"
            mat-cell
            *matCellDef="let fileOrOutflow"
          >
            <ng-container *ngIf="fileOrOutflow?.outflowType != null">
              <button
                mat-icon-button
                (click)="
                  openDialogAddFoodItemToAdditionalOutflow(fileOrOutflow);
                  $event.stopPropagation()
                "
                class="icon-24 icon-orange"
                [ngClass]="{
                  'icon-Active': fileOrOutflow.menu?.nombreMenu,
                  '': !fileOrOutflow.menu?.nombreMenu
                }"
              >
                <i-tabler name="paper-bag" class="icon-20"></i-tabler>
              </button>
            </ng-container>
            <ng-container *ngIf="fileOrOutflow?.outflowType == null">
              <button
                mat-icon-button
                (click)="
                  openDialogFileDetails(fileOrOutflow); $event.stopPropagation()
                "
              >
                <i-tabler name="file" class="icon-24 icon-orange"></i-tabler>
              </button>
            </ng-container>
          </td>
        </ng-container>

        <ng-container matColumnDef="expand">
          <th
            class="f-w-600 f-s-15 custom-column"
            mat-header-cell
            *matHeaderCellDef
          >
            Acciones
          </th>
          <td
            class="f-s-14 custom-column"
            mat-cell
            *matCellDef="let fileOrOutflow"
          >
            <ng-container *ngIf="fileOrOutflow?.outflowType != null">
              <button
                mat-icon-button
                color="primary"
                (click)="deleteAdditionalOutflow(fileOrOutflow)"
              >
                <mat-icon class="icon-color">delete</mat-icon>
              </button>
            </ng-container>
            <ng-container *ngIf="fileOrOutflow?.outflowType == null">
              <button
                mat-icon-button
                aria-label="expand row"
                (click)="
                  currentExpandedFile =
                    currentExpandedFile === fileOrOutflow
                      ? null
                      : fileOrOutflow;
                  $event.stopPropagation()
                "
              >
                <mat-icon *ngIf="currentExpandedFile !== fileOrOutflow"
                  >keyboard_arrow_down</mat-icon
                >
                <mat-icon *ngIf="currentExpandedFile === fileOrOutflow"
                  >keyboard_arrow_up</mat-icon
                >
              </button>
            </ng-container>
          </td>
        </ng-container>

        <ng-container matColumnDef="expandedDetail" sticky>
          <th
            class="f-w-600 f-s-15 custom-column"
            mat-header-cell
            *matHeaderCellDef
          ></th>
          <td
            class="f-s-14 custom-column"
            mat-cell
            *matCellDef="let fileRow"
            [attr.colspan]="displayedColumns.length"
          >
            <ng-container *ngIf="fileRow?.outflowType == null">
              <app-table-expand
                *ngIf="currentExpandedFile === fileRow"
                [file]="fileRow"
                [fileServices]="fileRow.services"
                [fileInsumos]="fileRow.insumos"
              ></app-table-expand>
            </ng-container>
          </td>
        </ng-container>

        <tr
          mat-header-row
          *matHeaderRowDef="displayedColumns; sticky: true"
        ></tr>
        <tr
          mat-row
          *matRowDef="let element; columns: displayedColumns"
          class="example-element-row"
          [class.example-expanded-row]="currentExpandedFile === element"
          (click)="
            currentExpandedFile =
              currentExpandedFile === element ? null : element
          "
        ></tr>
        <tr
          mat-row
          *matRowDef="let row; columns: ['expandedDetail']"
          class="example-detail-row"
        ></tr>
      </table>
    </mat-card-content>
    <div [hidden]="isLoading" class="w-100">
      <mat-paginator [pageSizeOptions]="[5, 10, 20]" showFirstLastButtons>
      </mat-paginator>
    </div>
  </mat-card-content>

  <div
    *ngIf="!isLoading && dataSource?.filteredData?.length === 0"
    class="d-flex justify-content-center align-items-center"
    style="width: 100%; height: 400px; text-align: center"
  >
    Lo sentimos. No tenemos datos para esta búsqueda.
    <br />Por favor, intenta con otro término.
  </div>
</mat-card>
